import { message } from 'antd';
import { client } from '../../../actions';

export const getMaxBindingStatus = async ({ login, password }) => {
  try {
    const response = await client.post(
      '/TwoFactAuth/max/binding_status',
      { login, password },
      {}
    );
    return response.data;
  } catch (e) {
    console.error(e);
    message.error('Не получилось проверить привязку к Max');
    return null;
  }
};
